<template>
  <div class="app-wrapper">
    <navbar />
    <sidebar />
    <div class="main-container" :class="{ 'sidebar-collapse': !sidebarOpened }">
      <app-main />
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { Navbar, AppMain, Sidebar } from './components'

export default {
  name: 'LayoutComponent',
  components: {
    Navbar,
    AppMain,
    Sidebar
  },
  setup() {
    const store = useStore()
    
    const sidebarOpened = computed(() => store.state.app.sidebar.opened)
    
    return {
      sidebarOpened
    }
  }
}
</script>

<style lang="scss" scoped>
.app-wrapper {
  position: relative;
  height: 100vh;
  width: 100%;
  overflow: hidden;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.main-container {
  height: calc(100vh - 60px);
  transition: margin-left 0.28s;
  margin-left: 210px;
  margin-top: 60px; // 为固定导航栏留出空间
  position: relative;
  overflow-y: auto;
  
  // 当侧边栏折叠时，调整主内容区域
  &.sidebar-collapse {
    margin-left: 64px;
  }
}
</style>
